const domain = "file";
export {
  domain
};
//# sourceMappingURL=types.js.map
